console.log("LIGHTBOX 26 JS LOADED");

// fade text effect
function createFadeText(elementId, words, interval = 2000, fadeDuration = 800) {
  const el = document.getElementById(elementId);
  if (!el || !words.length) return;

  let index = 0;

  setInterval(() => {
    el.classList.add("fade-out");

    setTimeout(() => {
      index = (index + 1) % words.length;
      el.textContent = words[index];
      el.classList.remove("fade-out");
    }, fadeDuration);

  }, interval);
}

// Run after DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  createFadeText("ef-fad", ["Clarity", "Clarity", "Stamina", "Immunity"], 3000, 3000);
});

/* Drag-scroll filter strip */
  (function() {
    var strip = document.getElementById('col-filts');
    if (!strip) return;
    var dragging=false, startX=0, startScroll=0;
    strip.addEventListener('mousedown', function(e) { dragging=true; startX=e.pageX; startScroll=strip.scrollLeft; strip.classList.add('dragging'); e.preventDefault(); });
    document.addEventListener('mouseup', function() { dragging=false; strip.classList.remove('dragging'); });
    document.addEventListener('mousemove', function(e) { if (!dragging) return; strip.scrollLeft = startScroll-(e.pageX-startX)*1.2; });
  })();

(function () {

  function waitForGallery() {

    var gallery = document.querySelector('.led-gallery');
    var lb = document.getElementById('led-lb');
    var img = document.getElementById('led-lb-img');
    var closeBtn = document.getElementById('led-lb-close');
    var prevBtn = document.getElementById('led-lb-prev');
    var nextBtn = document.getElementById('led-lb-next');

    if (!gallery || !lb || !img) {
      setTimeout(waitForGallery, 300);
      return;
    }

    var index = 0;

    function images() {
      return Array.from(document.querySelectorAll('.led-gal-img img'))
        .map(function (i) { return i.src; });
    }

    function open(i) {
      var imgs = images();
      index = i;
      if (!imgs.length) return;

      img.src = imgs[index];
      lb.classList.add('on');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lb.classList.remove('on');
      document.body.style.overflow = '';
    }

    // 🔥 FORCE EVENT (CAPTURE + DIRECT BODY LISTENER)
    document.body.addEventListener('click', function (e) {

      var el = e.target;

      while (el && !el.classList?.contains('led-gal-img')) {
        el = el.parentElement;
      }

      if (!el) return;

      var items = Array.from(document.querySelectorAll('.led-gal-img'));
      var i = items.indexOf(el);

      if (i >= 0) open(i);

    }, true);

    // controls
    if (closeBtn) closeBtn.onclick = close;

    if (prevBtn) prevBtn.onclick = function () {
      var imgs = images();
      index = (index - 1 + imgs.length) % imgs.length;
      open(index);
    };

    if (nextBtn) nextBtn.onclick = function () {
      var imgs = images();
      index = (index + 1) % imgs.length;
      open(index);
    };

    lb.onclick = function (e) {
      if (e.target === lb) close();
    };

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('on')) return;

      var imgs = images();

      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') open((index - 1 + imgs.length) % imgs.length);
      if (e.key === 'ArrowRight') open((index + 1) % imgs.length);
    });

    console.log("LIGHTBOX FORCE READY ✔");

  }

  waitForGallery();

})();

(function() {
  var imgs = ['https://aliveinnovations.com/cdn/shop/files/Showerheadpicture2_1024x1024@2x.png?v=1761762341', 'https://aliveinnovations.com/cdn/shop/files/10_000_gauss_Ad_1024x1024@2x.png?v=1761762362', 'https://aliveinnovations.com/cdn/shop/files/3_Layer_Fabric_Filter_1024x1024@2x.png?v=1761762361', 'https://aliveinnovations.com/cdn/shop/files/Filter_Photo_1_1024x1024@2x.png?v=1761762363', 'https://aliveinnovations.com/cdn/shop/files/Filter_Photo_3_1024x1024@2x.png?v=1761762361', 'https://aliveinnovations.com/cdn/shop/files/Installing_Filter_Photo_1024x1024@2x.png?v=1761762362', 'https://aliveinnovations.com/cdn/shop/files/Shower_head_picture_1_1024x1024@2x.png?v=1761762361', 'https://aliveinnovations.com/cdn/shop/files/showerhead_after_filter_picture_after_30_days_1024x1024@2x.jpg?v=1761762361'];
  var idx = 0;
  window.shLb = function(i) { idx=i; document.getElementById('sh-lb-img').src=imgs[i]; document.getElementById('sh-lb').classList.add('on'); document.body.style.overflow='hidden'; };
  window.shLbClose = function() { document.getElementById('sh-lb').classList.remove('on'); document.body.style.overflow=''; };
  window.shLbNav = function(d) { idx=(idx+d+imgs.length)%imgs.length; document.getElementById('sh-lb-img').src=imgs[idx]; };
  document.getElementById('sh-lb').addEventListener('click',function(e){ if(e.target===this) shLbClose(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') shLbClose(); if(e.key==='ArrowRight') shLbNav(1); if(e.key==='ArrowLeft') shLbNav(-1); });
})();

/* Drag-scroll filter strip */
  
